module.exports = __webpack_public_path__ + "media/images/bilietai-3addffc5.svg";